import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import GiftTwoToneSvg from "@ant-design/icons-svg/es/asn/GiftTwoTone";
import AntdIcon from "../components/AntdIcon";
var GiftTwoTone = function GiftTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GiftTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  GiftTwoTone.displayName = 'GiftTwoTone';
}
export default /*#__PURE__*/React.forwardRef(GiftTwoTone);